import Client from './clients/Client'

export default {
  liveICEDutchTTF () {
    const date = Date.now()
    return Client.get(`https://api.investing.com/api/financialdata/1178699/historical/chart/?interval=PT5M&pointscount=120&date=${date}`)
  }
}
